// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"159":"40b74181b98c3d66","717":"288a3a33a910d90e","896":"0da1fae4504e953a"}[chunkId] + ".js";
};